import { h3SetToMultiPolygon } from 'h3-js';
import React from 'react';

const isMyMap = (map) => (map && map.getDiv && map.getDiv().id === "google-map");

class GoogleMap extends React.Component {
  componentDidMount() {
    if (!window.google) return;
    const dom = document.getElementById("google-map");
    const map = new window.google.maps.Map(dom, {
      center: { lat: 37.535235, lng: 127.094842 },
      zoom: 12
    });
    this.props.setMap(map);
  }

  render() {
    return (
      <>
        <div id="google-map" style={{ height: window.innerHeight - 56 }}></div>
      </>
    );
  }
}

const GoogleMapMarker = (props) => {
  const { map, markers } = props;
  const infos = [];

  isMyMap(map) && markers.forEach(m => {
    const position = { lat: m.position[0], lng: m.position[1] };
    const marker = new window.google.maps.Marker({
      position,
      map
    });

    const info = new window.google.maps.InfoWindow({
      content: `<div style="padding:4px">${m.name}</div>`
    });
    infos.push(info);

    marker.addListener("click", () => {
      infos.forEach(v => v.close());
      setTimeout(() => {
        info.open({
          anchor: marker,
          map,
          shouldFocus: false,
        });
      });
    });
  });

  return (<></>);
}

const GoogleMapCircle = (props) => {
  const { map, circles } = props;

  isMyMap(map) && circles.forEach(circle => {
    new window.google.maps.Circle({
      center: { lat: circle.center[0], lng: circle.center[1] },
      radius: circle.radius,
      map,
      ...circle.style
    });
  });

  return (<></>);
}

const GoogleMapIndex = (props) => {
  const { map, indexes } = props;

  isMyMap(map) && indexes.forEach(idx => {
    const multiPolygon = h3SetToMultiPolygon([idx], true);
    multiPolygon.forEach(polygon => {
      const boundary = polygon[0] || [];
      const paths = boundary.map(coords => ({ lat: coords[1], lng: coords[0] }));
      new window.google.maps.Polygon({
        paths,
        map,
        ...polygon.style
      });
    });
  });

  return (<></>);
}

export { GoogleMap, GoogleMapMarker, GoogleMapCircle, GoogleMapIndex };
